
<div class="report-template-step">
    <form ref="form" @submit.prevent>
        <!-- Name Input -->
        <label>Name <span class="text-danger">*</span></label>
        <CInput v-model="formData.name" class="mb-4" placeholder="Input schedule report name" required />

        <!-- Schedule Section -->
        <h5 style="font-weight: 700;">Schedule</h5>
        <div class="schedule-section mt-3 mb-4">
            <div class="d-flex align-items-center mb-3" style="gap: 24px;">
                <div class="custom-control custom-radio">
                    <input type="radio" id="weekly" value="weekly" v-model="formData.schedule_type"
                        class="custom-control-input">
                    <label class="custom-control-label" for="weekly">Weekly</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="monthly" value="monthly" v-model="formData.schedule_type"
                        class="custom-control-input">
                    <label class="custom-control-label" for="monthly">Monthly</label>
                </div>
            </div>
            <p class="my-0" style="font-size: 13px; font-weight: 700;">
                {{ scheduleDescription }}
            </p>
        </div>
        <v-divider class="ma-0 mb-4" color="#D7D7D7"></v-divider>

        <!-- Select Report Template Section -->
        <h5 style="font-weight: 700;">Select Report Template</h5>
        <div class="mt-3">
            <div class="d-flex align-items-start" style="gap: 16px;">
                <div>
                    <label>Category <span class="text-danger">*</span></label>
                    <div style="width: 190px;">
                        <CSelectNew v-model="formData.category" :options="reportCategoryList" item-text="label"
                            item-value="value" placeholder="Select category" required />
                    </div>
                </div>
                <div style="width: 100%;">
                    <label>Template Name <span class="text-danger">*</span></label>
                    <div class="template-select-row">
                        <CSelectNew class="template-select" v-model="formData.template_id" :options="reportTemplates" item-text="name"
                            item-value="id" placeholder="Select template" :disabled="!formData.category" required />
                        <div class="edit-template-button" v-if="formData.template_id">
                            <a :href="`/dashboard/template_builder/${formData.template_id}`">
                                <span class="mdi mdi-pencil-outline"></span> Edit Template
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>

    <div class="preview-container" :style="{ backgroundColor: !selectedTemplate ? '#F4F4F4' : 'transparent' }">
        <!-- Empty State - Show when no template selected -->
        <div v-if="!selectedTemplate" class="empty-state text-center py-5">
            <p class="mb-0" style="color: #3F3F3F;">Select Report Template to show preview</p>
        </div>

        <!-- Filter Section (show when template selected) -->
        <div v-if="selectedTemplate">
            <div class="">
                <h5 style="font-weight: 700;">Filter</h5>
                <p  class="mb-4 mt-2"><i>Some filters shown below are pre-configured in the report template.</i></p>
            </div>
            <ColumnFilter class="mb-4" :filter-options="selectedTemplate.filter_options || []"
                :saved-filters="resolvedSavedFilters" :organization-id="organizationId"
                :management-business-department="managementBusinessDepartment"
                :reference-date="nextRunDate"
                @update:filters="handleFilterUpdate" />
            <div v-if="hasDynamicDateFilter" class="dynamic-date-filter-banner mb-4">
                Dynamic date filters automatically update based on the scheduled send date.
                Exported data may change each time this report is sent.
                Total <b>{{ formattedDataCount }}</b> data based on the applied filters.
            </div>
        </div>

        <!-- Column Preview Section -->
        <div v-if="selectedTemplate" class="mt-4">
            <ColumnDetail :template-id="formData.template_id" :schedule-id="initialData?.id"
                :filters="formData.filters" @run-report="handleRunReport" />
        </div>
    </div>
</div>
